// import React, { useEffect, useRef, useState } from 'react';


// // Assets
// // import imgProduct from "../assets/images/img7.jpg"; 

// const MiddleSection = () => {
//   const sectionRef = useRef(null);
//   const [isVisible, setIsVisible] = useState(false);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         // Update state based on visibility
//         // If visible = true (Play Animation)
//         // If hidden = false (Reset Animation)
//         setIsVisible(entry.isIntersecting);
//       },
//       { 
//         threshold: 0.2 // Trigger when 20% of the section is visible
//       }
//     );

//     if (sectionRef.current) {
//       observer.observe(sectionRef.current);
//     }

//     return () => {
//       if (sectionRef.current) {
//         observer.disconnect();
//       }
//     };
//   }, []);

//   return (
//     <section 
//       className={`graph-section ${isVisible ? 'in-view' : ''}`} 
//       ref={sectionRef}
//     >
//       <div className="container position-relative h-100">
        
//         {/* --- Header --- */ }
//         <div className="text-center mb-5 position-relative z-2 header-content">
//             {/* <span className="graph-subtitle">Clinical Formulation</span> */}
//             <h2 className="graph-title">मजबूत शरीर, स्वस्थ जीवन <span>मोरिंगा के साथ”</span></h2>
//         </div>

//         {/* --- The Graph Container --- */}
//         <div className="graph-container">
          
//           {/* 1. Center Hub (The Product) */}
//           <div className="center-hub">
//             <div className="pulse-circle"></div>
//             <div className="pulse-circle delay-1"></div>
            
//             <div className="product-wrapper">
//                 <img src="../../../images/centerprdct.png" alt="Moringa Bottle" />
//                 {/* The Scanner Line Animation */}
//                 {/* <div className="scanner-line"></div> */}
//             </div>
//           </div>

//           {/* 2. The Satellites (Ingredient Cards) */}
          
//           {/* Top Left */}
//           <div className="satellite sat-tl">
//             <div className="connector-line line-tl"></div>
//             <div className="info-card">
//                 <div className="icon-box">C</div>
//                 <div className="text-content">
//                     <h4>1. एंटीऑक्सीडेंट शक्ति </h4>
//                     <p>Free radicals से बचाव और शरीर को detox करता है</p>
//                 </div>
//             </div>
//           </div>

//           {/* Top Right */}
//           <div className="satellite sat-tr">
//             <div className="connector-line line-tr"></div>
//             <div className="info-card">
//                 <div className="icon-box">Fe</div>
//                 <div className="text-content">
//                     <h4>2. इम्यूनिटी बूस्टर</h4>
//                     <p>रोग प्रतिरोधक क्षमता को मजबूत बनाता है</p>
//                 </div>
//             </div>
//           </div>

//           {/* Bottom Left */}
//           <div className="satellite sat-bl">
//             <div className="connector-line line-bl"></div>
//             <div className="info-card">
//                 <div className="icon-box">Ha</div>
//                 <div className="text-content">
//                     <h4>3. पोषण से भरपूर</h4>
//                     <p>विटामिन, मिनरल्स और प्रोटीन का खजाना</p>
//                 </div>
//             </div>
//           </div>

//           {/* Bottom Right */}
//           <div className="satellite sat-br">
//             <div className="connector-line line-br"></div>
//             <div className="info-card">
//                 <div className="icon-box">E</div>
//                 <div className="text-content">
//                     <h4>4. प्राकृतिक ऊर्जा</h4>
//                     <p>दिनभर की थकान दूर कर ऊर्जा बढ़ाता है</p>
//                 </div>
//             </div>
//           </div>

//         </div>

//       </div>
//     </section>
//   );
// };

// export default MiddleSection;















// import React, { useEffect, useRef, useState } from 'react';
// import { Sparkles, ShieldCheck, Leaf, Zap } from 'lucide-react';

// const MoringaMandala = () => {
//   const sectionRef = useRef(null);
//   const [isVisible, setIsVisible] = useState(false);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => setIsVisible(entry.isIntersecting),
//       { threshold: 0.2 }
//     );
//     if (sectionRef.current) observer.observe(sectionRef.current);
//     return () => observer.disconnect();
//   }, []);

//   const satelliteBenefits = [
//     { icon: <Sparkles />, title: "एंटीऑक्सीडेंट", pos: "top", img: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?q=80&w=1000" },
//     { icon: <ShieldCheck />, title: "इम्यूनिटी", pos: "right", img: "https://images.unsplash.com/photo-1512290923902-8a9f81dc236c?q=80&w=1000" },
//     { icon: <Leaf />, title: "शुद्ध पोषण", pos: "bottom", img: "https://images.unsplash.com/photo-1540555700478-4be289fbecef?q=80&w=1000" },
//     { icon: <Zap />, title: "प्राकृतिक ऊर्जा", pos: "left", img: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?q=80&w=1000" },
//   ];

//   return (
//     <>
//       <style>{`
//         .mandala-section {
//           padding: 160px 0;
//           background: #FDFBF7; /* Warm Herbal White */
//           overflow: hidden;
//           position: relative;
//         }

//         .mandala-container {
//           max-width: 1200px;
//           margin: 0 auto;
//           position: relative;
//           height: 800px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//         }

//         /* --- Central Anchor --- */
//         .mandala-center {
//           width: 380px;
//           height: 380px;
//           background: white;
//           border-radius: 50%;
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           justify-content: center;
//           z-index: 10;
//           box-shadow: 0 40px 100px rgba(27, 67, 50, 0.12);
//           border: 1px solid rgba(212, 175, 55, 0.3);
//           text-align: center;
//           padding: 40px;
//           transition: 0.8s cubic-bezier(0.16, 1, 0.3, 1);
//           opacity: ${isVisible ? '1' : '0'};
//           transform: scale(${isVisible ? '1' : '0.8'});
//         }

//         .mandala-center img {
//           width: 200px;
//           margin-bottom: 20px;
//           // animation: rotateSoft 20s linear infinite;
//         }

//         @keyframes rotateSoft {
//           from { transform: rotate(0deg); }
//           to { transform: rotate(360deg); }
//         }

//         /* --- Satellite Cards --- */
//         .satellite-card {
//           position: absolute;
//           width: 240px;
//           height: 240px;
//           overflow: hidden;
//           background: white;
//           border: 1px solid rgba(212, 175, 55, 0.2);
//           box-shadow: 0 20px 50px rgba(0,0,0,0.05);
//           transition: all 1s cubic-bezier(0.19, 1, 0.22, 1);
//           opacity: ${isVisible ? '1' : '0'};
//         }

//         .satellite-card img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           opacity: 0.7;
//           transition: 0.6s;
//         }

//         .satellite-card:hover img {
//           opacity: 1;
//           transform: scale(1.1);
//         }

//         /* Positioning Logic */
//         .pos-top { top: 0; transform: translateY(${isVisible ? '0' : '-50px'}); transition-delay: 0.2s; }
//         .pos-bottom { bottom: 0; transform: translateY(${isVisible ? '0' : '50px'}); transition-delay: 0.4s; }
//         .pos-left { left: 0; transform: translateX(${isVisible ? '0' : '-50px'}); transition-delay: 0.6s; }
//         .pos-right { right: 0; transform: translateX(${isVisible ? '0' : '50px'}); transition-delay: 0.8s; }

//         /* Overlay Text */
//         .satellite-overlay {
//           position: absolute;
//           inset: 0;
//           background: linear-gradient(to top, rgba(27, 67, 50, 0.8), transparent);
//           display: flex;
//           flex-direction: column;
//           justify-content: flex-end;
//           padding: 20px;
//           color: white;
//         }

//         .satellite-icon {
//           color: #D4AF37;
//           margin-bottom: 10px;
//         }

//         .satellite-title {
//           font-family: var(--font-display);
//           font-size: 1.4rem;
//           margin: 0;
//         }

//         /* Floating Animation */
//         .float-anim {
//           animation: floatSway 6s ease-in-out infinite;
//         }
//         @keyframes floatSway {
//           0%, 100% { transform: translateY(0) rotate(0deg); }
//           50% { transform: translateY(-15px) rotate(2deg); }
//         }

//         @media (max-width: 992px) {
//           .mandala-container { height: auto; flex-direction: column; gap: 40px; padding: 40px 20px; }
//           .satellite-card { position: relative; width: 100%; height: 200px; transform: none !important; opacity: 1 !important; }
//           .mandala-center { width: 100%; height: auto; border-radius: 20px; }
//         }
//       `}</style>

//       <section className="mandala-section" ref={sectionRef}>
//         <div className="container">
//           <div className="mandala-container">
            
//             {/* Satellite 1: Top */}
//             <div className={`satellite-card pos-top float-anim`}>
//               <img src={satelliteBenefits[0].img} alt="benefit" />
//               <div className="satellite-overlay">
//                 <div className="satellite-icon">{satelliteBenefits[0].icon}</div>
//                 <h4 className="satellite-title">{satelliteBenefits[0].title}</h4>
//               </div>
//             </div>

//             {/* Satellite 2: Left */}
//             <div className={`satellite-card pos-left float-anim`} style={{ animationDelay: '1s' }}>
//               <img src={satelliteBenefits[3].img} alt="benefit" />
//               <div className="satellite-overlay">
//                 <div className="satellite-icon">{satelliteBenefits[3].icon}</div>
//                 <h4 className="satellite-title">{satelliteBenefits[3].title}</h4>
//               </div>
//             </div>

//             {/* Central Anchor */}
//             <div className="mandala-center">
//               <span style={{ fontFamily: 'var(--font-sans)', fontSize: '0.65rem', letterSpacing: '5px', color: '#D4AF37', marginBottom: '15px' }}>
//                 PURE SOURCE
//               </span>
//               <img src="/images/centerprdct.png" alt="Moringa Powder" />
//               <h3 style={{ fontFamily: 'var(--font-display)', fontSize: '2.2rem', color: '#1B4332', margin: 0 }}>
//                 मोरिंगा अमृत
//               </h3>
//               <p style={{ fontFamily: 'var(--font-sans)', fontSize: '0.85rem', color: '#666', marginTop: '10px', lineHeight: '1.6' }}>
//                 मजबूत शरीर और स्वस्थ जीवन के लिए <br/> प्रकृति का दिव्य उपहार।
//               </p>
//             </div>

//             {/* Satellite 3: Right */}
//             <div className={`satellite-card pos-right float-anim`} style={{ animationDelay: '2s' }}>
//               <img src={satelliteBenefits[1].img} alt="benefit" />
//               <div className="satellite-overlay">
//                 <div className="satellite-icon">{satelliteBenefits[1].icon}</div>
//                 <h4 className="satellite-title">{satelliteBenefits[1].title}</h4>
//               </div>
//             </div>

//             {/* Satellite 4: Bottom */}
//             <div className={`satellite-card pos-bottom float-anim`} style={{ animationDelay: '1.5s' }}>
//               <img src={satelliteBenefits[2].img} alt="benefit" />
//               <div className="satellite-overlay">
//                 <div className="satellite-icon">{satelliteBenefits[2].icon}</div>
//                 <h4 className="satellite-title">{satelliteBenefits[2].title}</h4>
//               </div>
//             </div>

//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default MoringaMandala;






// import React, { useEffect, useRef, useState } from "react";

// const MiddleSection = () => {
//   const sectionRef = useRef(null);
//   const [isVisible, setIsVisible] = useState(false);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => setIsVisible(entry.isIntersecting),
//       { threshold: 0.2 }
//     );

//     if (sectionRef.current) observer.observe(sectionRef.current);

//     return () => observer.disconnect();
//   }, []);

//   return (
//     <>
//       <style>{`
//         .az-middle-sec {
//           background: #f3f0eb;
//           padding: 60px 20px;
//           min-height: 800px;
//           overflow: hidden;
//         }

//         .az-middle-sec-header {
//           text-align: center;
//           margin-bottom: 40px;
//           opacity: 0;
//           transform: translateY(-30px);
//           transition: 0.6s;
//         }

//         .az-middle-sec.in-view .az-middle-sec-header {
//           opacity: 1;
//           transform: translateY(0);
//         }

//         .az-middle-sec-header h2 {
//           font-size: 34px;
//         }

//         .az-middle-sec-container {
//           position: relative;
//           max-width: 900px;
//           margin: auto;
//           height: 600px;
//         }

//         /* Center */
//         .az-center {
//           position: absolute;
//           top: 50%;
//           left: 50%;
//           transform: translate(-50%, -50%) scale(0.5);
//           opacity: 0;
//           transition: 0.8s;
//         }

//         .az-middle-sec.in-view .az-center {
//           transform: translate(-50%, -50%) scale(1);
//           opacity: 1;
//         }

//         .az-center img {
//           width: 160px;
//           z-index: 2;
//           position: relative;
//         }

//         /* Pulse */
//         .az-pulse {
//           position: absolute;
//           width: 200px;
//           height: 200px;
//           border-radius: 50%;
//           border: 2px solid #5a6c57;
//           top: 50%;
//           left: 50%;
//           transform: translate(-50%, -50%);
//           animation: azRipple 4s infinite;
//         }

//         .az-pulse.delay {
//           animation-delay: 2s;
//         }

//         @keyframes azRipple {
//           0% { transform: translate(-50%, -50%) scale(1); opacity: 0.5; }
//           100% { transform: translate(-50%, -50%) scale(2); opacity: 0; }
//         }

//         /* Satellite Images */
//         .az-item {
//           position: absolute;
//           opacity: 0;
//           transform: scale(0.5);
//           transition: 0.8s;
//         }

//         .az-middle-sec.in-view .az-item {
//           opacity: 1;
//           transform: scale(1);
//         }

//         .az-item img {
//           width: 80px;
//           border-radius: 15px;
//           // box-shadow: 0 10px 30px rgba(0,0,0,0.15);
//           transition: 0.3s;
//         }

//         .az-item img:hover {
//           transform: scale(1.1);
//         }

//         /* Positions */
//         .az-tl { top: 10%; left: 10%; }
//         .az-tr { top: 10%; right: 10%; }
//         .az-bl { bottom: 10%; left: 10%; }
//         .az-br { bottom: 10%; right: 10%; }

//         /* Mobile */
//         @media(max-width:768px){
//           .az-middle-sec-container {
//             height: auto;
//             display: flex;
//             flex-direction: column;
//             align-items: center;
//             gap: 20px;
//           }

//           .az-center {
//             position: static;
//             transform: none !important;
//             opacity: 1 !important;
//           }

//           .az-item {
//             position: static;
//             opacity: 1 !important;
//             transform: none !important;
//           }
//         }
//       `}</style>

//       <section
//         className={`az-middle-sec ${isVisible ? "in-view" : ""}`}
//         ref={sectionRef}
//       >
//         <div className="az-middle-sec-header">
//           <h2>
//             मजबूत शरीर, स्वस्थ जीवन <span>मोरिंगा के साथ</span>
//           </h2>
//         </div>

//         <div className="az-middle-sec-container">

//           {/* Center */}
//           <div className="az-center">
//             <div className="az-pulse"></div>
//             <div className="az-pulse delay"></div>
//             <img src="/images/centerprdct.png" alt="product" />
//           </div>

//           {/* Images instead of text */}
//           <div className="az-item az-tl">
//             <img src="/images/centerprdct.png" alt="benefit1" />
//           </div>

//           <div className="az-item az-tr">
//             <img src="/images/centerprdct.png" alt="benefit2" />
//           </div>

//           <div className="az-item az-bl">
//             <img src="/images/centerprdct.png" alt="benefit3" />
//           </div>

//           <div className="az-item az-br">
//             <img src="/images/centerprdct.png" alt="benefit4" />
//           </div>

//         </div>
//       </section>
//     </>
//   );
// };

// export default MiddleSection;














// import React, { useEffect, useRef, useState } from "react";

// const MiddleSection = () => {
//   const sectionRef = useRef(null);
//   const [isVisible, setIsVisible] = useState(false);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => setIsVisible(entry.isIntersecting),
//       { threshold: 0.2 }
//     );

//     if (sectionRef.current) observer.observe(sectionRef.current);

//     return () => observer.disconnect();
//   }, []);

//   return (
//     <>
   

//       <section
//         className={`az-middle-sec ${isVisible ? "in-view" : ""}`}
//         ref={sectionRef}
//       >
//         <div className="az-middle-sec-header">
//           <h2>
//             मजबूत शरीर, स्वस्थ जीवन <span>मोरिंगा के साथ</span>
//           </h2>
//         </div>

//         <div className="az-middle-sec-container">

//           {/* Center */}
//           <div className="az-center">
//             <div className="az-pulse"></div>
//             <div className="az-pulse delay"></div>
//             <img src="/images/centerprdct.png" alt="product" />
//           </div>

//           {/* Images + TEXT */}
//           <div className="az-item az-tl">
              
//             <img src="/images/centerprdct.png" alt="benefit1" />
//             <p>एंटीऑक्सीडेंट शक्ति मोरिंगा के साथ </p>
//               <p>एंटीऑक्सीडेंट शक्ति मोरिंगा के साथ </p>
//           </div>

//           <div className="az-item az-tr">
//             <img src="/images/centerprdct.png" alt="benefit2" />
//             <p>इम्यूनिटी बूस्टर मोरिंगा के साथ</p>
//               <p>एंटीऑक्सीडेंट शक्ति मोरिंगा के साथ </p>
//           </div>

//           <div className="az-item az-bl">
//             <img src="/images/centerprdct.png" alt="benefit3" />
//             <p>पोषण से भरपूर मोरिंगा के साथ</p>
//               <p>एंटीऑक्सीडेंट शक्ति मोरिंगा के साथ </p>
//           </div>

//           <div className="az-item az-br">
//             <img src="/images/centerprdct.png" alt="benefit4" />
//             <p>प्राकृतिक ऊर्जा मोरिंगा के साथ</p>
//               <p>एंटीऑक्सीडेंट शक्ति मोरिंगा के साथ </p>
//           </div>

//         </div>
//       </section>
//     </>
//   );
// };

// export default MiddleSection;




import React, { useEffect, useRef, useState } from "react";

const MiddleSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.2 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <section
      className={`az-middle-sec ${isVisible ? "in-view" : ""}`}
      ref={sectionRef}
    >
      <div className="az-middle-sec-header">
        <h2>
         प्राकृतिक आयुर्वेदिक घृत  <span>सम्पूर्ण स्वास्थ्य का आधार </span>
        </h2>
      </div>

      <div className="  container  az-middle-sec-container">

        {/* Center (same as before with animation) */}
        <div className="az-center">
          <div className="az-pulse"></div>
          <div className="az-pulse delay"></div>
          <img src="../images/Ghrit1.png" alt="product" />
        </div>

        {/* Side Images (NO animation now) */}
        <div className="az-item az-tl">
          <div className="az-img-circle mb-3">
            <img src="../images/Ghrit2.png" alt="benefit1" />
          </div>
          <p>हर्बल आयुर्वेदिक सिरप अपने शरीर को  प्राकृतिक रूप से मजबूत बनाएं</p>
          {/* <p> प्राकृतिक रूप से मजबूत बनाएं</p> */}
        </div>

        <div className="az-item az-tr">
          <div className="az-img-circle mb-3">
            <img src="../images/Ghrit3.png" alt="benefit2" />
          </div>
          {/* <p>इम्यूनिटी बूस्टर मोरिंगा के साथ एंटीऑक्सीडेंट शक्ति मोरिंगा के साथ</p> */}
         <p>यह सिरप शरीर की रोग प्रतिरोधक क्षमता बढ़ाने में मदद करता है</p>
          {/* <p>और आपको अंदर से स्वस्थ व ऊर्जावान बनाता है।</p> */}
        </div>

        <div className="az-item az-bl">
          <div className="az-img-circle mb-3">
            <img src="../images/Ghrit4.png" alt="benefit3" />
          </div>
          {/* <p>पोषण से भरपूर मोरिंगा के साथ एंटीऑक्सीडेंट शक्ति मोरिंगा के साथ</p> */}
          <p>इसका तेज़ असर करने वाला और सुरक्षित लिक्विड फॉर्मूला आपकी</p>
          {/* <p>रोज़मर्रा की सेहत को सपोर्ट करता है</p> */}
        </div>

        <div className="az-item az-br">
          <div className="az-img-circle mb-3">
            <img src="../images/Ghrit5.png" alt="benefit4" />
            
          </div>
          {/* <p>प्राकृतिक ऊर्जा मोरिंगा के साथ एंटीऑक्सीडेंट शक्ति मोरिंगा के साथ</p> */}
          <p>इसमें किसी भी प्रकार के हानिकारक केमिकल्स का उपयोग नहीं किया गया है</p>
         {/* <p>जिससे यह पूरी तरह से सुरक्षित और भरोसेमंद है।</p> */}
          
        </div>

      </div>
    </section>
  );
};

export default MiddleSection;